import React, { Fragment, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ActionType } from 'src/components/CapAction/constants';
import s from './CapEditField.styles';
import sf from '../CapFinding/CapFinding.styles';

const CapEditActionTypeAndActionTaken = ({
  type,
  value,
  actionType,
  onSave,
  editable,
}) => {
  const { t } = useTranslation();

  const [editing, setEditing] = useState(false);
  const [currentActionType, setCurrentActionType] = useState(
    actionType || ActionType.Corrective,
  );

  const inputRef = useRef(null);
  const isTextarea = type === 'textarea';
  const TextFieldComponent = isTextarea ? s.TextAreaField : s.TextField;
  const onClickSave = async () => {
    await onSave({
      actionTaken: inputRef.current.value,
      actionType: currentActionType,
    });
    setEditing(false);
  };

  const onClickEdit = async () => {
    if (!editable) {
      return;
    }
    await setEditing(true);
    inputRef.current.focus();
  };

  const onClickEmptyEdit = () => {
    if (!editable) {
      return;
    }
    setEditing(true);
  };

  const divFunction = () => {
    if (!editing && !value) {
      return (
        <div>
          <s.Row>
            {actionType ? (
              <s.ActionTypeSpan
                preventiveAction={actionType === ActionType.Preventive}
              >{(actionType === ActionType.Preventive) ? t('CAP_PREVENTIVE_ACTION') : t('CAP_CORRECTIVE_ACTION')}</s.ActionTypeSpan>
            ) : (
              <sf.Label>{t('CAP_ACTION_TYPE')}</sf.Label>
            )}
          </s.Row>
          <s.Row>
            <s.EditDiv
              editable={editable}
              onClick={onClickEmptyEdit}
              vertical-center
            >
              <s.PlaceHolderText>{t('EMPTY')}</s.PlaceHolderText>
            </s.EditDiv>
          </s.Row>
        </div>
      );
    }
    if (!editing && value) {
      return (
        <div>
          <s.Row>
            <s.ActionTypeSpan
              preventiveAction={actionType === ActionType.Preventive}
            >{(actionType === ActionType.Preventive) ? t('CAP_PREVENTIVE_ACTION') : t('CAP_CORRECTIVE_ACTION')}</s.ActionTypeSpan>
          </s.Row>
          <s.Row>
            <s.EditDiv
              border
              editable={editable}
              onClick={onClickEdit}
              vertical-center
            >
              <sf.Text centerAligned={!isTextarea}>{value}</sf.Text>
            </s.EditDiv>
          </s.Row>
        </div>
      );
    }
    return (
      <div>
        <s.Row action-button-row>
          <s.RadioGroupItemRow>
            <s.RadioGroupItem>
              <s.RadioGroupInput
                checked={currentActionType === ActionType.Corrective}
                name={'action_type'}
                onChange={() => setCurrentActionType(ActionType.Corrective)}
                type="radio"
                value={ActionType.Corrective}
              />
              <s.RadioGroupCircle />
              <s.RadioGroupText>{t('CAP_CORRECTIVE_ACTION')}</s.RadioGroupText>
            </s.RadioGroupItem>
          </s.RadioGroupItemRow>

          <s.RadioGroupItemRow>
            <s.RadioGroupItem>
              <s.RadioGroupInput
                checked={currentActionType === ActionType.Preventive}
                name={'action_type'}
                onChange={() => setCurrentActionType(ActionType.Preventive)}
                type="radio"
                value={ActionType.Preventive}
              />
              <s.RadioGroupCircle />
              <s.RadioGroupText>{t('CAP_PREVENTIVE_ACTION')}</s.RadioGroupText>
            </s.RadioGroupItem>
          </s.RadioGroupItemRow>
        </s.Row>

        <s.Row>
          <TextFieldComponent defaultValue={value} ref={inputRef} type="text" />
        </s.Row>
        <s.Row paddingForButtons>
          <s.Button onClick={onClickSave} orange sm solid>{t('SAVE')}</s.Button>
          <s.Button ghost onClick={() => setEditing(false)} red sm>
            {t('CANCEL')}
          </s.Button>
        </s.Row>
      </div>
    );
  };

  return <Fragment>{divFunction()}</Fragment>;
};

CapEditActionTypeAndActionTaken.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  actionType: PropTypes.string,
  onSave: PropTypes.func,
  editable: PropTypes.bool,
};

CapEditActionTypeAndActionTaken.defaultProps = {};

export default React.memo(CapEditActionTypeAndActionTaken);
